module.exports = __webpack_public_path__ + "static/media/Ticket.7160e8c3.png";